module.exports = __webpack_public_path__ + "assets/bf3d91949d914a832ea43700dde51c70.mp3";